"use client"

import React from "react"
import { Outlet } from "react-router-dom"

// Components
import DashboardHeader from "../DashboardHeader/DashboardHeader"
import DashboardSidebar from "../DashboardSidebar/DashboardSidebar"
import Modal from "../GuestPage/Modal/Modal"
import DemoForm from "../GuestPage/Demo-form/DemoForm"

// Context
import { ConnectorFlowProvider } from "../../context/ConnectorFlowContext"

// Hooks
import { useDashboardLayout } from "../../hooks/useDashboardLayout"

// Styles
import "./DashboardLayout.css"

const DashboardLayout: React.FC = () => {
  const { isModalOpen, closeModal, handleDemoClick, handleFormSubmit, sidebarCollapsed, toggleSidebar, mainClassName } =
    useDashboardLayout()

  return (
    <div className="dashboard-layout">
      <DashboardHeader onToggleSidebar={toggleSidebar} onDemoClick={handleDemoClick} />

      <div className="dashboard-body">
        <DashboardSidebar collapsed={sidebarCollapsed} />

        <main className={mainClassName}>
          <ConnectorFlowProvider>
            <div className="dashboard-content">
              <Outlet />
            </div>
          </ConnectorFlowProvider>
        </main>
      </div>

      {isModalOpen && (
        <Modal isOpen={isModalOpen} onClose={closeModal}>
          <DemoForm onSubmit={handleFormSubmit} onClose={closeModal} />
        </Modal>
      )}
    </div>
  )
}

export default React.memo(DashboardLayout)
